// gotta keep it within MAX_SAFE_INTEGER
const extraDigits = 3

module.exports = createRandomId


function createRandomId(){
  // 13 time digits
  var datePart = new Date().getTime()*Math.pow(10, extraDigits)
  // 3 random digits
  var extraPart = Math.floor(Math.random()*Math.pow(10, extraDigits))
  // 16 digits
  return datePart+extraPart
}


//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/web3-provider-engine/util/random-id.js
// module id = 1429
// module chunks = 0 1 2